import * as React from "react";

import { Label } from "semantic-ui-react";

import { Link } from "redux-little-router";

interface Props {
    href: string;
    icon: string;
    label?: string;
    count?: number;
}

export const DashboardIcon: React.FunctionComponent<Props> = (props: Props) => {
    return (
        <div className="dashboard-icon">
            <Link href={props.href}>
                <div className="icon">
                    <img src={props.icon} />
                    {props.count !== undefined &&
                        <Label className="counter" size="huge" circular floating color="red" content={props.count} />}
                </div>
                <h2 className="label">{props.label}</h2>
            </Link>
        </div>
    );
};
